<form class="details-screen" #formRef="ngForm">
<ng-container *ngIf="publication">
	<bb-page-header [icon]="'cog'" [title]="'PUBLICATION_SETTINGS' | translate">
		<ul class="tabs">
			<li>
				<a class="active">
					<i class="fa fa-cog"></i> {{ 'SETTINGS' | translate }}
				</a>
			</li>
		</ul>
	</bb-page-header>

	<div class="body-column">
		<bb-form-element [form]="form" [label]="'IP_FILTER_STATS' | translate" [helpMessage]="'HELP.IP_FILTER_STATS' | translate">
			<bb-entity-selector 
				[(ngModel)]="ipFilters"
				(ngModelChange)="onFiltersChanged($event)"
				[extendable]="true"
				[multi]="true"
				[ngModelOptions]="{standalone: true}"
			></bb-entity-selector>
		</bb-form-element>
		
		<bb-form-element [form]="form" [label]="'DEFAULT_DEEP_LINK' | translate" [helpMessage]="'HELP.DEFAULT_DEEP_LINK' | translate:{fields: deepLinkFields}">
			<input
				type="text"
				name="deeplinkTemplate"
				[(ngModel)]="publication.deeplinkTemplate"
			/>
		</bb-form-element>

		<bb-form-element [form]="form" [label]="'AUTO_DEEP_LINK_DOMAINS' | translate" [helpMessage]="'HELP.AUTO_DEEP_LINK_DOMAINS' | translate:{fields: deepLinkFields}" class="{{ publication?.deeplinkTemplate ? 'disabled' : '' }}">
			<bb-entity-selector 
				[(ngModel)]="publication.autoDeeplinkDomains"
				name="autoDeeplinkDomains"
				[extendable]="true"
				[multi]="true"
			></bb-entity-selector>
		</bb-form-element>
		
		<bb-form-element [form]="form" [label]="'ENABLE_ADVERTISING' | translate" [helpMessage]="'HELP.ENABLE_ADVERTISING' | translate">
			<!-- warning: reversed boolean ahead -->
			<bb-status [(ngModel)]="publication.disablePositions" name="disablePositions" [labelOn]="' ' | translate" [labelOff]="' ' | translate" [valueOff]="'true'" [valueOn]="'false'" [standAlone]="true"></bb-status>
		</bb-form-element>

		<bb-form-element [hasPublicationField]="'showExtraPlayoutFields'" [form]="form" [label]="'ENABLE_EXTRA_OPTIONS' | translate" [helpMessage]="'HELP.ENABLE_EXTRA_OPTIONS' | translate">
			<bb-entity-selector 
				[(ngModel)]="publication.extraPlayoutFields"
				name="extraPlayoutFields"
				[extendable]="true"
				[options]="extraPlayoutFieldsOptions"
				[multi]="true"
			></bb-entity-selector>
		</bb-form-element>

		<bb-form-element [form]="form" [hasPublicationField]="'customCode'"
		[label]="'PUBLICATION_CUSTOM_CODE' | translate" [helpMessage]="'HELP.PUBLICATION_CUSTOM_CODE' | translate"
		[helpMessageLink]="'https://support.bluebillywig.com/outstreamads/outstream-ads-ad-unit-general-settings/#8-0-miscellaneous'">
			<bb-code-editor name="customCode" [(ngModel)]="publication.customCode"></bb-code-editor>
		</bb-form-element>

		<div [hasPublicationField]="'useWhitelabel'">
			<h3>
				{{ 'WHITELABEL_CONFIG' | translate }}
			</h3>

			<bb-form-element [form]="form" [label]="'CUSTOM_OVP_TITLE' | translate">
				<input
					type="text"
					name="whitelabelTitle"
					[(ngModel)]="publication.whitelabelTitle"
				/>
			</bb-form-element>
			<bb-form-element [form]="form" [label]="'CUSTOM_OVP_LOGO' | translate">
				<bb-logo-selector [autoPublish]="true" [useType]="'commercial'" [mediaTypes]="['image']" [(entityId)]="whitelabelLogoId"
					(entityIdChange)="setSelectedImage('whitelabelLogoId')"></bb-logo-selector>
			</bb-form-element>

			<bb-form-element [form]="form" [label]="'CUSTOM_OVP_HEADER_IMAGE' | translate">
				<bb-logo-selector [autoPublish]="true" [useType]="'commercial'" [mediaTypes]="['image']" [(entityId)]="whitelabelHeaderImageId"
					(entityIdChange)="setSelectedImage('whitelabelHeaderImageId')"></bb-logo-selector>
			</bb-form-element>

			<bb-form-element [form]="form" [label]="'CUSTOM_OVP_FAVICON' | translate">
				<bb-logo-selector [autoPublish]="true" [useType]="'commercial'" [mediaTypes]="['image']" [(entityId)]="whitelabelFaviconId"
					(entityIdChange)="setSelectedImage('whitelabelFaviconId')"></bb-logo-selector>
			</bb-form-element>
			
			<bb-form-element [form]="form" [label]="'OVP_CSS_OVERRIDE' | translate" [helpMessage]="'HELP.OVP_CSS_OVERRIDE' | translate">
				<textarea [(ngModel)]="publication.ovpCssOverride" name="ovpCssOverride" [placeholder]="('ENTER_CSS' | translate)"></textarea>
			</bb-form-element>
		
			<bb-form-element [form]="form" [label]="'OVP_CUSTOM_HOME_URL' | translate" [helpMessage]="'HELP.OVP_CUSTOM_HOME_URL' | translate">
				<input
					type="text"
					name="ovpCustomHomeUrl"
					[(ngModel)]="publication.ovpCustomHomeUrl"
				/>
			</bb-form-element>
		</div>

		<div>
			<h3>{{ "THUMBNAILS" | translate }}</h3>
				<publication-custom-thumbnails 
					[(ngModel)]="publication.customThumbnailSets" name="customThumbnailSets" [form]="form">
				</publication-custom-thumbnails>
		</div>

		<div>
			<h3>{{ 'REACT_BRANDING' | translate }}</h3>
			<bb-form-element [form]="form" [label]="'REACT_BRANDING_TITLE' | translate" [helpMessage]="'HELP.REACT_BRANDING_TITLE' | translate">
				<input type="text" name="reactTitle" [(ngModel)]="publication.reactTitle" />
			</bb-form-element>
			<bb-form-element [form]="form" [label]="'REACT_BRANDING_LOGO' | translate" [helpMessage]="'HELP.REACT_BRANDING_LOGO' | translate">
				<bb-logo-selector [autoPublish]="true" [useType]="'commercial'" [mediaTypes]="['image']" [(entityId)]="reactLogoId"
					(entityIdChange)="setSelectedImage('reactLogoId')"></bb-logo-selector>
			</bb-form-element>
			<bb-form-element [form]="form" [label]="'REACT_BRANDING_HIGHLIGHT' | translate" class="input-overflow-visible" [helpMessage]="'HELP.REACT_BRANDING_HIGHLIGHT' | translate">
				<bb-color-picker-box [(ngModel)]="publication.reactHighlight" default="3693ef" pickerPosition="left" [excludeHexHash]="true" name="reactHighlight"></bb-color-picker-box>
			</bb-form-element>
		</div>

		<div [hasPermission]="'root'">
			<h3>
				{{ 'DYNAMIC_CONFIG_FIELDS' | translate }}
			</h3>
			<div>
				<input
					type="text" 
					placeholder="New field key"
					[(ngModel)]="newFieldName"
					[ngModelOptions]="{standalone: true}"
				/>
				<button class="button" [disabled]="!newFieldName" (click)="addNewFieldClick()">Add new field</button>
			</div>
			<ng-container *ngFor="let field of publicationFields">
				<bb-form-element [form]="form" [label]="field.label">
					<bb-field-renderer
						[(ngModel)]="publication[field.name]"
						[fieldConfig]="field"
						[name]="field.name"
					></bb-field-renderer>
					<span class="delete-field" (click)="deleteCustomField(field.name)" [title]="'DELETE' | translate">
						<i class="fa fa-trash"></i>
					</span>
				</bb-form-element>
			</ng-container>
		</div>
	</div>
</ng-container>
</form>
<bb-actions-bar (onSave)="save()" (onCancel)="cancel()" [form]="form"></bb-actions-bar>
